import { render } from "./SiteManagerFooterMenu.vue?vue&type=template&id=7ba41cfe&ts=true"
import script from "./SiteManagerFooterMenu.vue?vue&type=script&lang=ts"
export * from "./SiteManagerFooterMenu.vue?vue&type=script&lang=ts"

import "./SiteManagerFooterMenu.vue?vue&type=style&index=0&id=7ba41cfe&lang=css"
/* custom blocks */
import block0 from "./SiteManagerFooterMenu.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__